module.exports = __webpack_public_path__ + "img/universe-other.12cabfb6.png";